import { createFileRoute } from "@tanstack/react-router";
import heroImg from "@/assets/storm.jpg";
import { ServicePage } from "@/components/ServicePage";
import { services } from "@/lib/service-content";
import { faqJsonLd, serviceJsonLd, breadcrumbJsonLd } from "@/lib/site";

export const Route = createFileRoute("/storm-debris-removal")({
  head: () => ({
    meta: [
      { title: services["storm-debris-removal"].metaTitle },
      { name: "description", content: services["storm-debris-removal"].metaDescription },
      { property: "og:title", content: services["storm-debris-removal"].metaTitle },
      { property: "og:description", content: services["storm-debris-removal"].metaDescription },
      { property: "og:url", content: "https://anchorsrq.com/storm-debris-removal" },
    ],
    links: [{ rel: "canonical", href: "https://anchorsrq.com/storm-debris-removal" }, { rel: "preload", as: "image", href: heroImg, fetchpriority: "high" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(breadcrumbJsonLd([{ name: 'Home', url: 'https://anchorsrq.com/' }, { name: 'Services', url: 'https://anchorsrq.com/#services' }, { name: 'Storm Debris Removal', url: 'https://anchorsrq.com/storm-debris-removal' }])) },
      { type: "application/ld+json", children: JSON.stringify(serviceJsonLd({ slug: "storm-debris-removal", name: 'Storm Debris Removal', serviceType: 'Storm Debris Removal', description: 'Rapid post-storm debris hauling across the Sarasota coast — downed limbs, fence sections, ruined patio furniture, and damaged building materials cleared by Anchor Services, with insurance documentation on request.' })) },
      { type: "application/ld+json", children: JSON.stringify(faqJsonLd(services["storm-debris-removal"].faqs)) },
    ],
  }),
  component: () => <ServicePage {...services["storm-debris-removal"]} heroImg={heroImg} />,
});
